module.exports = __webpack_public_path__ + "static/media/trash.8e2b9198.svg";